/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading components
 * -----------------------------------------------------------------------------------------------------------
 */
import auth from 'src/router/auth'
import Region from '../Region'
import NewRegion from '../NewRegion'
import EditRegion from '../EditRegion'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Define component
 * -----------------------------------------------------------------------------------------------------------
 */
export default [
  {
    path: '/regions',
    name: 'region',
    component: Region,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/regions/create',
    name: 'create-region',
    component: NewRegion,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/regions/edit/:id',
    name: 'edit-region',
    component: EditRegion,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/region/routes/index.js